<template>
    <div class="color-morado">
        <v-container >

            <v-row justify="center" align="center">
                <v-col cols="auto" class="pt-10 " align-self="center">
                    <div class="mx-auto" style="max-width: 600px;">
                        <span class="titulos-size bold d-block mb-3">{{renta.titulo}}</span>
                        
                        <span class="subtitulo mb-3 d-none" v-html="renta.subtitulo"></span>
                        <hr class="d-none mt-6" style=" color:#FFF; max-width:90%;">
                    </div>
                </v-col>
            </v-row>
                

            <v-row class="py-5">
                <v-col >
                    <v-form id="contactForm" v-model="valid" lazy-validation ref="form">
                        <v-container class="pa-8 pa-md-0">
                            <v-row justify-md="center">
                                <v-col cols="12" md="12">
                                    <v-select  label="Servicio" dense outlined color="#5C27B2"  :items="renta.servicio.value" v-model="form.servicio" :rules="emptyRule" required></v-select>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <v-text-field  label="Nombre" outlined color="#5C27B2" v-model="form.nombre" :rules="emptyRule" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <v-text-field  label="Correo" outlined color="#5C27B2" v-model="form.correo" :rules="emailRule" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <v-text-field  label="Teléfono" outlined color="#5C27B2" v-model="form.telefono" :rules="phoneRule" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="py-0">
                                    <v-text-field  label="Ciudad" outlined color="#5C27B2" v-model="form.ciudad" :rules="emptyRule" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="12" class="py-0">  
                                    <v-textarea outlined name="input-7-4" label="Mensaje" v-model="form.mensaje" :rules="emptyRule" required></v-textarea>
                                </v-col>

                                <v-col cols="auto" style="color:#FFF;" class="text-center py-0">
                                    <v-checkbox color="#5C27B2" hide-details="true" class="py-0 my-0" v-model="checkbox" :rules="emptyRule" required>
                                        <template v-slot:label class="py-0" >
                                            <div style="color:#5C27B2; padding:0;">
                                                Confirmo que he leído los
                                                <router-link to="/terminos-y-condiciones"  style="color:blue; text-decoration:none;">Términos</router-link> y <router-link to="/terminos-y-condiciones" style="color:blue; text-decoration:none;">condiciones</router-link>
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>

                            
                            <v-row justify="center">
                                <v-col class="text-center py-10">
                                    <v-btn outlined x-large color="#5C27B2" :disabled="!valid" @click="validateFields">Enviar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-snackbar v-model="snackbar" >
                        Información enviada

                        <template v-slot:action="{ attrs }">
                            <v-btn
                            color="pink"
                            text
                            v-bind="attrs"
                            @click="snackbar = false"
                            >
                            Close
                            </v-btn>
                        </template>
                        </v-snackbar>
                </v-col>
            </v-row>
        </v-container>

        
    </div>
</template>
<script>
export default {
    data(){
        return{
            renta:{
                servicio:{
                    value:{}
                }

            },
            snackbar:false,
            valid:true,
            checkbox:false,
            
            form:{
            servicio:null,
            nombre:'',
            correo:'',
            telefono:'',
            ciudad:'',
            mensaje:''
            },
            emptyRule:[
                validation => !!validation || 'El Campo  es requerido',
            ],
            emailRule: [
                validation => !!validation || 'Correo es requerido',
                
                validation =>  /.+@.+\..+/.test(validation) || 'El formato no es correcto',
            ],
            phoneRule: [
                validation => !!validation || 'Teléfono es requerido ',
                validation =>  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(validation) || 'El formato no es correcto',
                validation => (validation && validation.length <= 10) || 'El teléfono debe tener 10 digitos',
                
            ],
            items: ['Fibra oscura', 'Ethernet', 'Torres BTS', 'Indoor DAS'],

        }

    },
    mounted: function(){
    fetch('http://nncms.actstudio.xyz/api/singletons/get/RentaServicios?token=8cf7ca41761951fdde0c1e2cfda401')
    .then(data => data.json())
    .then(data => this.renta = data);
    },
    methods:{
      enviarForm:function(){
          
        fetch('http://nncms.actstudio.xyz/api/forms/submit/RentaServicios?token=8cf7ca41761951fdde0c1e2cfda401', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                form: this.form
            })
        })
        .then(entry => entry.json())
        .then(()=> this.snackbar = true)
        .then(()=> this.$refs.form.reset())
        },
        limpiarForm:function(){
            this.form.nombre = '';
            this.form.ciudad = '';
            this.form.correo = '';
            this.form.telefono = '';
            this.form.mensaje = '';

        },
        validateFields () {
            var result = this.$refs.form.validate();
            
            if(result){
                this.enviarForm();
                
            }

        },
    }
    
}
</script>